// extracted by mini-css-extract-plugin
module.exports = {"pdp-info-wrap":"ProductInfo_pdp-info-wrap__6yOSZ","accordian-title":"ProductInfo_accordian-title__Pb4X3","tabs":"ProductInfo_tabs__0zJh4"};